<template>
  <div class="g-bd">
    <div class="con-tag news-tag">
      <h2>新 <span>/</span>闻 <span>/</span>资 <span>/</span>讯</h2>
    </div>
    <div class="con-body news-body">
      <div class="con-detail">
        <div class="item-title">{{ detailForm.title }}</div>
        <div class="item-date">
          <span v-if="detailForm.source != ''"
            >来源：{{ detailForm.source }}</span
          >
          <span v-if="detailForm.author != ''"
            >作者：{{ detailForm.author }}</span
          >
          <span>发布时间：{{ detailForm.createdDt || "-" }}</span>
        </div>
        <div class="item-content">
          <!-- <div v-if="detailForm.summary" class="item-con-title">摘要：{{detailForm.summary}}</div> -->
          <div
            class="item-news-content ql-editor"
            v-html="detailForm.details"
          ></div>
          <div v-if="detailForm.url" class="item-con-title">
            原文链接：{{ detailForm.url }}
          </div>
          <div v-if="detailForm.docList != ''" class="item-con-title">
            <h4>附件下载:</h4>
            <ul>
              <li v-for="item in detailForm.docList" :key="item.id">
                <a
                  :href="`${$setting.baseURL}/api/oss/download/download?fileId=${item.docId}`"
                  >{{ item.title }}</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
export default {
  components: {},
  name: "newsDetail",
  data() {
    return {
      id: "",
      detailForm: {},
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getdetail();
  },
  methods: {
    getdetail() {
      let par = {
        id: this.id,
      };
      this.$http
        .post("/api/web/article/getById", par)
        .then((res) => {
          this.detailForm = res.data;
        })
        .catch((msg) => {
          console.log(msg);
        });
    },
  },
};
</script>
<style lang="scss">
</style>
